<h1 mat-dialog-title>DELETE WORKOUT</h1>
<div mat-dialog-content>
  <p>{{message}}</p>
</div>
<div mat-dialog-actions class="float-right">
  <button mat-button (click)="modalRemoveWorkoutCancel()">CANCEL</button>
  <button mat-button [ngClass]="{'hidden': canDelete==false}"  (click)="removeWorkout(workout)" cdkFocusInitial>YES</button>
</div>